module.exports = __webpack_public_path__ + "assets/ic_weather01.be0f4250.svg";